var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSatellite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0007 8.30396C15.2659 8.30396 14.6714 8.89844 14.6714 9.63322C14.6714 10.368 15.2659 10.9625 16.0007 10.9625C18.9331 10.9625 21.3175 13.3472 21.3175 16.2793C21.3175 17.0141 21.9119 17.6086 22.6467 17.6086C23.3815 17.6086 23.976 17.0141 23.976 16.2793C23.976 11.8814 20.3985 8.30396 16.0007 8.30396Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.634 17.6086C27.3687 17.6086 27.9632 17.0141 27.9632 16.2794C27.9632 9.68272 22.597 4.31604 15.9999 4.31604C15.2651 4.31604 14.6707 4.91052 14.6707 5.6453C14.6707 6.38009 15.2651 6.97457 15.9999 6.97457C21.1299 6.97457 25.3046 11.1492 25.3046 16.2792C25.3048 17.0143 25.8991 17.6085 26.6338 17.6085L26.634 17.6086Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0007 0.328737C15.2659 0.328737 14.6714 0.923218 14.6714 1.658C14.6714 2.39278 15.2659 2.98726 16.0007 2.98726C23.3292 2.98726 29.2927 8.95066 29.2927 16.2793C29.2927 17.0141 29.8872 17.6086 30.6219 17.6086C31.3567 17.6086 31.9512 17.0141 31.9512 16.2793C31.9512 7.48377 24.796 0.328613 16.0005 0.328613L16.0007 0.328737Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5591 28.721C7.86583 33.041 14.6448 33.3732 19.337 29.7178C19.9751 29.226 20.0281 28.2824 19.4565 27.7109L12.9568 21.2111L15.3229 18.845C15.5355 18.9115 15.7617 18.938 16.0008 18.938C17.4629 18.938 18.6593 17.7418 18.6593 16.2795C18.6593 14.8172 17.4629 13.621 16.0008 13.621C14.5387 13.621 13.3423 14.8172 13.3423 16.2795C13.3423 16.5186 13.3688 16.7578 13.4353 16.9709L11.0825 19.337L4.56913 12.8237C3.99731 12.2523 3.05374 12.3054 2.562 12.9435C-1.09316 17.6357 -0.760947 24.415 3.55905 28.7214L3.5591 28.721Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatellite);
export default __webpack_public_path__ + "static/media/satellite.8e01786cbfc9e7b26fab033731950b52.svg";
export { ForwardRef as ReactComponent };